import type { FC } from 'react'

import { ErrorMessage, StyledText, Swipeable } from '@skytech/ui'
import { useNavigate } from 'react-router-dom'

import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import useSubscriptionServices from '@/hooks/subscriptionServices'
import type { Invoice } from '@/types'

import { Translation } from '../i18n/Translation'

import type { Deadline } from './types'

const SalaryDeductionSummary: FC<{
  offset: number
  currentInvoice: Invoice | null
  deadline: Deadline
}> = ({ offset, currentInvoice: invoice, deadline }) => {
  const navigate = useNavigate()
  const subscriptionServices = useSubscriptionServices()

  const fixedSalaryDeduction =
    subscriptionServices
      ?.filter(service => new Date(service.activated) < new Date(invoice?.date || ''))
      .reduce((acc, cur) => acc + cur.price, 0) || 0

  const openDetails = () => {
    const path = `/dashboard/${offset}/salary-deduction`
    navigate(path)
  }

  if (!invoice) return null

  // TODO: refactor deadline handling to use the correct date format
  const getDeadline = () => {
    if (!deadline || deadline.passed || deadline.dayDeadline === 0) {
      return null
    }

    return (
      <ErrorMessage>
        <Translation id="Søkefrist {date}" values={{ date: deadline.date }} />
      </ErrorMessage>
    )
  }

  let totalAmount =
    invoice.salary_deduction_amount + invoice.salary_deduction_vat + fixedSalaryDeduction
  if (totalAmount < 0) {
    totalAmount = 0
  }

  return (
    <Swipeable
      id="salary-deduction-summary"
      className="section"
      onClick={openDetails}
      onSwipedLeft={openDetails}
    >
      <div className="amount">
        <FormattedNumberWithCurrency amount={totalAmount} precision={2} />
      </div>

      <StyledText colorMode="gray">
        <Translation id="Trekkes fra lønn" />
      </StyledText>

      {getDeadline()}
    </Swipeable>
  )
}

export default SalaryDeductionSummary
